import { motion } from "framer-motion";
import { EASE, lineChild, lineParent } from "@/lib/motion";

export const MaskLines = ({ lines, as = "h2", className = "", delay = 0, onLoad = false, testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} initial="hidden" variants={lineParent(delay)} data-testid={testId} {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block" variants={lineChild}>{line}</motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const SectionLabel = ({ index, label }) => (
  <Reveal className="flex items-center gap-4">
    <span className="eyebrow">{index} / {label}</span>
    <motion.span
      className="h-px w-16 origin-left bg-gold/60"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.2, delay: 0.2, ease: EASE }}
    />
  </Reveal>
);

export const Ticks = ({ className = "border-gold/70" }) => (
  <>
    <span aria-hidden className={`pointer-events-none absolute -left-px -top-px z-10 h-3 w-3 border-l border-t ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute -right-px -top-px z-10 h-3 w-3 border-r border-t ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute -bottom-px -left-px z-10 h-3 w-3 border-b border-l ${className}`} />
    <span aria-hidden className={`pointer-events-none absolute -bottom-px -right-px z-10 h-3 w-3 border-b border-r ${className}`} />
  </>
);
